import React from "react";
import moment from "moment";
import { FichaFinanceiraAssistidoService, PlanoService } from "../../services";
import { Alerta, Card, Row, Col, Box, Botao, CampoEstatico, TipoCampoEstatico, TipoAlerta } from "@intechprev/componentes-web";
import { MasterPage } from "..";
import { FichaFinanceiraAssistidoEntidade, ContrachequeEntidade } from "../../entidades";
import { reCAPTCHA } from "../../helpers";

interface Props {
  match?: any;
}

interface State {
  plano: any;
  contracheque: ContrachequeEntidade;
  outros: Array<FichaFinanceiraAssistidoEntidade>;
  cdPlano: string;
  dataReferencia: string;
  cdTipoFolha: string;
  cdEspecie: string;
}

var erro = false;
export default class ContrachequeDetalhe extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("contracheque_detalhe");

  private page = React.createRef<MasterPage>();
  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      plano: {},
      contracheque: new ContrachequeEntidade(),
      outros: [],
      cdPlano: props.match.params.plano,
      dataReferencia: props.match.params.data,
      cdTipoFolha: props.match.params.cdTipoFolha,
      cdEspecie: props.match.params.cdEspecie,
    };
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();

      const plano = await PlanoService.BuscarPorCodigo(this.state.cdPlano);

      const contracheque = await FichaFinanceiraAssistidoService.BuscarPorDataReferencia(
        this.state.cdPlano,
        this.state.dataReferencia,
        this.state.cdTipoFolha,
        this.state.cdEspecie
      );
      const outros = await FichaFinanceiraAssistidoService.BuscarPorDataReferenciaIncidLiquidoN(
        this.state.cdPlano,
        this.state.dataReferencia,
        this.state.cdTipoFolha,
        this.state.cdEspecie
      );

      await this.setState({ plano, contracheque, outros });

      this.escreverTitulo();

      await this.page.current.alternarLoading();
    } catch (err) {
      console.log(err);
    }
  };

  escreverTitulo = () => {
    const date = moment(this.state.dataReferencia, "DD-MM-YYYY").format("MM/YYYY");
    document.querySelector("#titulo").textContent = `Contracheque ${date}`;
  };

  gerarRelatorio = async () => {
    try {
      const relatorio = await FichaFinanceiraAssistidoService.GetRelatorio(
        this.state.cdPlano,
        this.state.dataReferencia,
        this.state.cdTipoFolha,
        this.state.cdEspecie,
        false
      );

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "contracheque.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "contracheque.pdf");
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error(err);
    }
  };

  renderPlanoInfo = () => {
    return (
      <div>
        <Row>
          <Col>
            <Card titulo={this.state.plano.DS_PLANO}>{"ASSISTIDO"}</Card>
          </Col>
          <Col>
            <Card titulo={"Referência"}>
              {this.state.contracheque.Resumo.DesTipoFolha + " - " + moment(this.state.dataReferencia, "DD.MM.YYYY").format("MM/YYYY")}
            </Card>
          </Col>
        </Row>
        <Row>
          {this.state.contracheque.Proventos.length > 0 && (
            <Col>
              <Card titulo={"ESPÉCIE"}>{this.state.contracheque.Proventos[0].DS_ESPECIE}</Card>
            </Col>
          )}
          <Col>
            <Card titulo={""}>
              <Row className={"text-center"}>
                <Col className={"col-lg-4"}>
                  <h5>BRUTO</h5>
                  <span className={"text text-info"}>
                    <CampoEstatico valor={this.state.contracheque.Resumo.Bruto} tipo={TipoCampoEstatico.dinheiro} />
                  </span>
                </Col>
                <Col className={"col-lg-4"}>
                  <h5>Descontos</h5>
                  <span className={"text text-danger"}>
                    <CampoEstatico valor={this.state.contracheque.Resumo.Descontos} tipo={TipoCampoEstatico.dinheiro} />
                  </span>
                </Col>
                <Col className={"col-lg-4"}>
                  <h5>LÍQUIDO</h5>
                  <span className={"text text-success"}>
                    <CampoEstatico valor={this.state.contracheque.Resumo.Liquido} tipo={TipoCampoEstatico.dinheiro} />
                  </span>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    );
  };

  renderFolhaInfoTable = (titulo: string, icone: string, tipoTexto: string, folha: any) => {
    const folhaRows = folha.map((folha: any, index: number) => {
      return (
        <tr key={index}>
          <td>{`${folha.CD_RUBRICA} - ${folha.DS_RUBRICA}`}</td>
          <td style={{ textAlign: "center" }}>{folha.TOT_PRESTACAO ? `${folha.NUM_PRESTACAO}/${folha.TOT_PRESTACAO}` : "-"}</td>
          <td style={{ width: 150, textAlign: "right" }}>
            <CampoEstatico valor={folha.VALOR_MC} tipo={TipoCampoEstatico.dinheiro} />
          </td>
        </tr>
      );
    });

    return (
      <Col className={"col-lg-6"}>
        <h2>
          <i className={`${icone} text-${tipoTexto}`}></i>
          {` ${titulo}`}
        </h2>
        <table className={"table table-striped"}>
          <thead>
            <tr>
              <th>Descrição</th>
              <th style={{ textAlign: "right" }}>Parâmetros</th>
              <th style={{ width: 150, textAlign: "right" }}>Valor</th>
            </tr>
          </thead>
          <tbody>{folhaRows}</tbody>
        </table>
      </Col>
    );
  };

  renderFolhaInfo = () => {
    return (
      <Col className={"col-lg-12"}>
        <Box>
          {this.state.contracheque.Proventos && (
            <>
              <Row>
                {this.renderFolhaInfoTable("Rendimentos", "fa fa-plus-circle", "success", this.state.contracheque.Proventos)}

                {this.renderFolhaInfoTable("Descontos", "fa fa-minus-circle", "danger", this.state.contracheque.Descontos)}

                {this.renderFolhaInfoTable("Base / Outros", "fas fa-info-circle", "warning", this.state.outros)}
              </Row>
              <Alerta ref={this.alerta} tipo={TipoAlerta.danger} />
              <Botao titulo={"Baixar PDF"} className={"btn btn-primary"} onClick={this.gerarRelatorio} usaLoading />
            </>
          )}
        </Box>
      </Col>
    );
  };

  renderComDetalhes = () => {
    return (
      <Box>
        {this.state.contracheque.Resumo && this.renderPlanoInfo()}

        <Row>{this.renderFolhaInfo()}</Row>
      </Box>
    );
  };

  renderSemDetalhes = () => {
    return <Alerta mensagem={"Não há detalhes para o mês escolhido!"} tipo={TipoAlerta.danger} />;
  };

  render() {
    return (
      <MasterPage {...this.props} ref={this.page}>
        {erro ? this.renderSemDetalhes() : this.renderComDetalhes()}
      </MasterPage>
    );
  }
}
